import { app_perm_template_request_hdr_RowClass } from "../../dbschema/app_perm_template_request_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class PermissionTemplateRequestHdrContainerModel extends BaseContainerModel{
    app_perm_template_request_hdr: app_perm_template_request_hdr_RowClass = new app_perm_template_request_hdr_RowClass();
}